/**
 * Vendor scripts loaded on demand by the surface that needs them, so public
 * maps and embeds never load billing, marketing, or social sign-in code.
 */
const loading = new Map<string, Promise<void>>();

async function loadScriptOnce(src: string, attrs: Record<string, string> = {}): Promise<void> {
    const pending = loading.get(src);
    if (pending !== undefined) return await pending;
    const promise = new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        Object.entries(attrs).forEach(([key, value]) => script.setAttribute(key, value));
        script.onload = () => resolve();
        script.onerror = () => {
            loading.delete(src);
            reject(new Error(`Could not load ${src}`));
        };
        document.head.appendChild(script);
    });
    loading.set(src, promise);
    return await promise;
}

export async function ensureChargebee(): Promise<void> {
    await loadScriptOnce('https://js.chargebee.com/v2/chargebee.js', { 'data-cb-site': 'proximaps', 'data-cb-ga-enabled': 'true' });
}

export async function ensureKlaviyo(): Promise<void> {
    await loadScriptOnce('https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=UZ8BYq');
}

export async function ensureGoogleIdentity(): Promise<void> {
    await loadScriptOnce('https://accounts.google.com/gsi/client');
}

export async function ensureFacebookSdk(): Promise<void> {
    if (window.FB !== undefined) return;
    const ready = new Promise<void>((resolve) => {
        window.fbAsyncInit = () => {
            window.FB.init({ appId: '4818436511616703', cookie: true, xfbml: true, version: 'v14.0' });
            resolve();
        };
    });
    await loadScriptOnce('https://connect.facebook.net/en_US/sdk.js');
    await ready;
}
